<template>
    <div class="flex flex-wrap">
        <div class="inline-block form-group w-full md:w-1/2" v-for="(field, index) in recordDetailCustomFields" v-if="field.enabled">
            <div class="col-md-12 text-md">
                {{ field.label_value }}
            </div>
            <div v-if="field.type == 2" class="col-md-12">
                <input type="text" class="form-control field-custom-height" v-model="advancedSearch[field.id]">
            </div>
            <div v-if="field.type == 4" class="col-md-12">
<!--                <datetime type="date"
                          v-model="advancedSearch[field.id]"
                          :use-utc="true"
                          :format="masks.date_mask"
                          :week-start="7"
                          class="form-control field-custom-height"/>-->
                <datepicker  v-model="advancedSearch[field.id]"  format="MM/dd/yyyy"
                             input-class="cursor-pointer rounded w-full p-1 text-grey-darkest text-sm focus:outline-none border-1 border-grey field-custom-height">
                </datepicker>
            </div>
            <div v-if="field.type == 1 || field.type == 3" class="col-md-12">
                <multiselect v-model="advancedSearch[field.id]"
                             :id="field.name + '-' + field.id"
                             :placeholder="'Select ' + field.name"
                             :options="field.options"
                             :multiple="true"
                             track-by="id"
                             label="name"
                             value="id"
                             :taggable="false"
                             :close-on-select="false">
                </multiselect>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';

export default {
    name: 'advanced-search-record-detail-custom-fields',
    components: {
        Datepicker,
        Multiselect
    },
    props: ['customFields', 'masks'],
    watch: {
        customFields: function(newVal, oldVal) {
            this.advancedSearch = newVal;
        },

    },
    data() {
        return {
            recordDetailCustomFields: {},
            advancedSearch: null,
            project_id : this.project_id ? this.project_id : '',
        };
    },
    created() {
        this.fetchCustomFields();
    },
    methods: {
        fetchCustomFields() {
            let self = this;
            axios.get(route('api.record-detail-custom-field.index') + '?project=true').then(({data}) => {
                self.recordDetailCustomFields = data.data;

                let  custom = {};
                for(let field in self.recordDetailCustomFields) {
                    custom[self.recordDetailCustomFields[field].id] = ''
                }

                self.advancedSearch = custom;
                if(self.localStorageValues) this.getLocalStorageValues();
            });
        },
        getFields() {
            let dateCustomField = this.recordDetailCustomFields.find(res=>res.type==4);
            if(dateCustomField && this.advancedSearch[dateCustomField.id] && this.advancedSearch[dateCustomField.id] !=="" ){
                console.log('value',this.advancedSearch[dateCustomField.id]);
                this.advancedSearch[dateCustomField.id] = new Date(this.advancedSearch[dateCustomField.id]).toISOString().split('T')[0];
                console.log('value after',this.advancedSearch[dateCustomField.id]);
            }
            return JSON.stringify(this.advancedSearch);
        },
        getLocalStorageValues() {
            const localStorageValues = JSON.parse(this.localStorageValues);
            for (let key in localStorageValues) {
                if (this.advancedSearch.hasOwnProperty(key)) {
                    this.advancedSearch[key] = localStorageValues[key];
                }
            }
        },
        clearFields() {
            for(let key in this.advancedSearch) {
                this.advancedSearch[key] = '';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.form-control {
    height: calc(1em + .75rem + 2px);
    padding: 0;
}

.vdp-datepicker {
    .form-control:disabled,
    .form-control[readonly] {
        background-color: white !important;
    }
}

.form-control:disabled,
.form-control[readonly] {
    background-color: white !important;
}
</style>
